import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Alert } from 'rsuite';
import { LOAD_ERROR_MESSAGE, PRICING_PERMISSION_QUERY_KEYS, SAVE_ERROR_MESSAGE, SAVE_SUCCESS_MESSAGE } from '../constants';
import { getContractUsers, getPriceApplicationConfig, savePriceApplicationConfig } from '../service';

export const usePriceApplicationConfigQuery = () =>
  useQuery({
    queryKey: PRICING_PERMISSION_QUERY_KEYS.config,
    queryFn: getPriceApplicationConfig,
    onError: () => Alert.error(LOAD_ERROR_MESSAGE),
  });

export const useContractUsersQuery = (enabled: boolean) =>
  useQuery({
    queryKey: PRICING_PERMISSION_QUERY_KEYS.contractUsers,
    queryFn: getContractUsers,
    enabled,
  });

export const useSavePriceApplicationConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: savePriceApplicationConfig,
    onSuccess: config => {
      queryClient.setQueryData(PRICING_PERMISSION_QUERY_KEYS.config, config);
      Alert.success(SAVE_SUCCESS_MESSAGE);
    },
    onError: () => Alert.error(SAVE_ERROR_MESSAGE),
  });
};
